<template>
  <component
    :is="'modal-' + template"
    :ref="refName"
    :ref-name="refName"
    :title="title"
    :first-button-text="firstButtonText"
    :second-button-text="secondButtonText"
    :first-button-sub-text="firstButtonSubText"
    :second-button-sub-text="secondButtonSubText"
    :first-button-style="firstButtonStyle"
    :second-button-style="secondButtonStyle"
    :icon-type="iconType"
    :icon-enabled="iconEnabled"
    :first-button-disabled="firstButtonDisabled"
    :second-button-disabled="secondButtonDisabled"
    :close-button-enabled="closeButtonEnabled"
    :buttons-enabled="buttonsEnabled"
    :size="'size-' + size"
    :warning-text="warningText"
    :warning-enabled="warningEnabled"
    :warning-action="warningAction"
    :hide-first-button="hideFirstButton"
    :hide-second-button="hideSecondButton"
    :dismiss-disabled="dismissDisabled"
    :hide-dismiss-link="hideDismissLink"
    :dismiss-text="dismissText"
    :header-clickable="headerClickable"
  >
    <slot />
  </component>
</template>

<script>
import Loading from './templates/Loading'
import Question from './templates/Question'
import Neutral from './templates/Neutral'
import Confirmation from './templates/Confirmation'
import Filter from './templates/Filter'
import mixin from './modalMixin'

export default {
  name: 'Modal',
  components: {
    'modal-question': Question,
    'modal-loading': Loading,
    'modal-neutral': Neutral,
    'modal-confirmation': Confirmation,
    'modal-filter': Filter
  },
  mixins: [mixin],
  props: {
    template: String
  }
}
</script>
